import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
    .catch((err) => console.error(err));

(function setup() {
    String.prototype.startsWith = String.prototype.startsWith || (function (needle: string): boolean {
        return this.indexOf(needle) === 0;
    });


    String.prototype.padStart = String.prototype.padStart || function padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };


    Date.prototype.formatShort = function () {
        return `${this.getFullYear()}-${this.getMonth() + 1}-${this.getDate()} ${this.getHours()}:${this.getMinutes()}:${this.getSeconds()}`;
    };

    Date.prototype.fromGermanString = function (germanString: string) {
        const tokens: string[] = germanString.split(/\./);
        this.setTime(0);
        this.setFullYear(Number(tokens[2]), Number(tokens[1]) - 1, Number(tokens[0]));
        return this;
    };

    Date.prototype.toLocaleDateString = function () {
        let dateString: string = this.getDate() >= 10 ? '' + this.getDate() : '0' + this.getDate();
        dateString += '.';

        let realMonth = this.getMonth() + 1;
        dateString += realMonth >= 10 ? realMonth : '0' + realMonth;
        dateString += '.';
        dateString += this.getFullYear();

        return dateString;
    };

    Number.prototype.formatMoney = function (n, x, s, c) {
        const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = this.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };

    console.debug = function (msg: any, ...optionalParams: any[]) {
        if (environment.production) {
            return;
        }

        console.log(msg, optionalParams);
    };

})();

